import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { sisaril } from "../../../assets/img/brand";
import moment from "moment";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

// ---------- Helpers ----------
const cell = (text, opts = {}) => ({
  text,
  margin: [3, 3, 3, 3], // espacio inferior para escribir
  fontSize: 8.8, // fuente más pequeña para que todo quepa
  ...opts,
});

const cell2 = (text, opts = {}) => ({
  text,
  margin: [3, 3, 3, 10], // espacio inferior para escribir
  fontSize: 8.8, // fuente más pequeña para que todo quepa
  ...opts,
});

const blockHeader = (title) => ({
  table: {
    widths: ["*"],
    body: [[{ text: title, color: "white", bold: true, margin: [8, 3, 8, 3] }]],
  },
  layout: {
    hLineWidth: () => 0,
    vLineWidth: () => 0,
    fillColor: () => "#1f6fb2",
  },
  margin: [0, 0, 0, 0],
});

const baseLayout = {
  hLineColor: () => "#b5c6d6",
  vLineColor: () => "#b5c6d6",
  hLineWidth: () => 0.7,
  vLineWidth: () => 0.7,
  paddingLeft: () => 5,
  paddingRight: () => 5,
  paddingTop: () => 3,
  paddingBottom: () => 4,
};

// ---------- Ajustes visuales ----------
const colLeft = "*";
const colMid = 65; // Código
const colMid2 = 125;
const colRight = 180; // Más ancho (Teléfono/Fecha)

// Tabla C (medicamentos)
const cName = "*";
const cQty = 55;
const cPend = 65;
const cAuth = 90;
const cDate = 70;
const paresMedicamentos = 6; // reducido a 6 para que todo quepa en una sola página

export function reportPartialDispatch({
  infoBranchOffice,
  infoPatient,
  telephone,
  nameRetire,
  loggedUserData,
}) {
  const docDefinition = {
    pageSize: "A4",
    pageMargins: [22, 20, 22, 22],
    defaultStyle: { fontSize: 8.8, lineHeight: 1.05 },
    content: [
      {
        columns: [
          [
            {
              margin: [0, 0, 0, 0],
              image: sisaril,
              width: 150,
            },
          ],
          [
            {
              text: "Formulario Despacho Parcial de Medicamentos",
              decoration: "underline",
              style: "title",
              margin: [0, 25, 0, 0],
            },
          ],
        ],
      },
      {
        columns: [
          {
            text: [
              { text: "ARS: " },
              {
                text: infoBranchOffice?.arsName || "",
                decoration: "underline",
              },
            ],
            alignment: "left",
            margin: [0, 10, 0, 20],
          },
        ],
      },
      // A. INFORMACIÓN DE LA FARMACIA ORIGEN
      blockHeader("A. INFORMACIÓN DE LA FARMACIA ORIGEN"),
      {
        table: {
          widths: [colLeft, colMid, colRight],
          body: [
            [
              cell({
                text: [
                  { text: "Razón social (Nombre de la farmacia): \n" },
                  { text: infoBranchOffice?.branch || "" },
                ],
              }),
              cell({
                text: [
                  { text: "CÓDIGO: \n" },
                  { text: infoBranchOffice?.code_pss || "" },
                ],
              }),
              cell({
                text: [
                  { text: "RNC: \n" },
                  { text: infoBranchOffice?.pharmacyProviderNIF || "" },
                ],
              }),
            ],
            [
              {
                ...cell({
                  text: [
                    { text: "Dirección (Calle, No., Ciudad): \n" },
                    { text: infoBranchOffice?.addressBranchOffice || "" },
                  ],
                }),
                colSpan: 2,
              },
              {},
              cell({
                text: [
                  { text: "Número telefónico (incluir código de área): \n" },
                  { text: infoBranchOffice?.phoneBranchOffice || "" },
                ],
              }),
            ],
            [
              {
                ...cell({
                  text: [
                    { text: "Nombre del Representante, firma y sello: \n" },
                    {
                      text: `${loggedUserData?.firstName || ""} ${
                        loggedUserData?.lastName || ""
                      }`,
                    },
                  ],
                }),
                colSpan: 2,
              },
              {},
              cell({
                text: [
                  { text: "Fecha en que se expide el Formulario: \n" },
                  { text: moment().format("DD/MM/YY") || "" },
                ],
              }),
            ],
          ],
        },
        layout: baseLayout,
        margin: [0, 0, 0, 0],
      },
      // 001-1137443-5
      // B. INFORMACIÓN DEL AFILIADO
      blockHeader("B. INFORMACIÓN DEL AFILIADO"),
      {
        table: {
          widths: [colLeft, colMid2, colRight],
          body: [
            [
              cell({
                text: [
                  { text: "Nombre del Afiliado (Apellidos, Nombres):  \n" },
                  { text: infoPatient?.fullname || "" },
                ],
              }),
              cell({
                text: [
                  { text: "Nombre de quien Retira: \n" },
                  { text: nameRetire || "" },
                ],
              }),
              cell({
                text: [
                  { text: "Número Seguridad Social (NSS) o Cédula: \n" },
                  {
                    text:
                      infoPatient?.Nss ||
                      infoPatient?.affiliateCardNumber ||
                      "",
                  },
                ],
              }),
            ],
            [
              {
                ...cell({
                  text: [
                    { text: "Dirección (Calle, No., Ciudad):  \n" },
                    { text: infoPatient?.address || "" },
                  ],
                }),
                colSpan: 2,
              },
              {},
              {
                ...cell({
                  text: [
                    {
                      text: "Número telefónico (incluir código de área):  \n",
                    },
                    {
                      text: (infoPatient?.phone || telephone || "").replace(
                        /(\d{3})(\d{3})(\d{4})/,
                        "($1) $2-$3"
                      ),
                    },
                  ],
                }),
              },
            ],
          ],
        },
        layout: baseLayout,
        margin: [0, 0, 0, 0],
      },

      // C. DE LOS MEDICAMENTOS
      blockHeader("C. DE LOS MEDICAMENTOS"),
      {
        table: {
          widths: [cName, cQty, cPend, cAuth, cDate],
          body: [
            [
              cell("Medicamento", {
                bold: true,
                alignment: "center",
              }),
              cell("Cantidad\nEntregada", { bold: true, alignment: "center" }),
              cell("Cantidad\nPendiente", {
                bold: true,
                alignment: "center",
              }),
              cell("Número de\nautorización", {
                bold: true,
                alignment: "center",
              }),
              cell("Fecha de entrega", {
                bold: true,
                alignment: "center",
              }),
            ],
            ...Array.from({ length: paresMedicamentos }).flatMap(() => [
              [
                { text: " ", rowSpan: 2, margin: [6, 8, 6, 0] },
                cell2(""),
                cell2(""),
                cell2(""),
                cell2(""),
              ],
              [{}, cell2(""), cell2(""), cell2(""), cell2("")],
            ]),
          ],
        },
        layout: baseLayout,
        margin: [0, 0, 0, 0],
      },

      // D. INFORMACIÓN DE LA FARMACIA (SEGUNDA ENTREGA)
      blockHeader("D. INFORMACIÓN DE LA FARMACIA (SEGUNDA ENTREGA)"),
      {
        table: {
          widths: [colLeft, colMid, colRight],
          body: [
            [
              cell("Razón social (Nombre de la farmacia): ", {
                margin: [6, 3, 6, 16],
              }),
              cell("CÓDIGO", {
                margin: [6, 3, 6, 16],
              }),
              cell("RNC", {
                margin: [6, 3, 6, 16],
              }),
            ],
            [
              {
                ...cell("Dirección (Calle, No., Ciudad): "),
                colSpan: 2,
                margin: [6, 3, 6, 16],
              },
              {},
              cell("Número telefónico (incluir código de área): ", {
                margin: [6, 3, 6, 16],
              }),
            ],
            [
              {
                ...cell("Nombre del Representante, firma y sello: "),
                colSpan: 2,
                margin: [6, 3, 6, 16],
              },
              {},
              cell(
                "Nombre completo y firma del afiliado o su representante: ",
                {
                  margin: [6, 3, 6, 16],
                }
              ),
            ],
          ],
        },
        layout: baseLayout,
        margin: [0, 0, 0, 0],
      },
    ],
    styles: {
      title: { fontSize: 12, bold: true, alignment: "center" },
    },
  };

  pdfMake.createPdf(docDefinition).open();
}
